var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"close absolute no-underline theme-ui-text-color",attrs:{"href":_vm.link}},[_c('i',{staticClass:"theme-question-shadow fa fa-times shadow-text-none"})])
}
var staticRenderFns = []

export { render, staticRenderFns }